import { render, staticRenderFns } from "./productInput.vue?vue&type=template&id=171f96d0"
import script from "./productInput.vue?vue&type=script&lang=js"
export * from "./productInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports